import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a54f05"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal__overlay",
  tabindex: "-1",
  "data-micromodal-close": ""
}
const _hoisted_3 = ["aria-labelledby"]
const _hoisted_4 = { class: "modal__header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "modal__footer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#send" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_RichTekst = _resolveComponent("RichTekst")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.modalId,
    "aria-hidden": "true",
    class: "modal"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        role: "dialog",
        class: "modal__container",
        "aria-modal": "true",
        "aria-labelledby": _ctx.modalId + '-title'
      }, [
        _createElementVNode("header", _hoisted_4, [
          _createElementVNode("h2", {
            class: "modal__title",
            id: _ctx.modalId + '-title'
          }, [
            _createVNode(_component_KlarTekst, { tekstNoegle: "tco.blanket.og-blanket.publicer-erstat-modal.overskrift" })
          ], 8, _hoisted_5)
        ]),
        _createElementVNode("main", {
          class: "modal__content .preserve-linebreaks",
          id: _ctx.modalId + '-content'
        }, [
          _createVNode(_component_RichTekst, { tekstNoegle: "tco.blanket.og-blanket.publicer-erstat-modal.beskrivelse" })
        ], 8, _hoisted_6),
        _createElementVNode("footer", _hoisted_7, [
          _createElementVNode("button", {
            id: "send-button-republish-modal",
            type: "button",
            class: "button button-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.publish()))
          }, [
            _hoisted_8,
            _createVNode(_component_KlarTekst, { tekstNoegle: "tco.blanket.og-blanket.publicer-erstat-modal.publicer.label" })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "button button-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
          }, [
            _createVNode(_component_KlarTekst, { tekstNoegle: "tco.blanket.og-blanket.publicer-erstat-modal.annuller.label" })
          ])
        ])
      ], 8, _hoisted_3)
    ])
  ], 8, _hoisted_1))
}